import Rails from '../rails/rails-ujs'
import Formatter from '../lib/formatter'

const Forms = {
  start () {
    // Limits text area length
    Rails.delegate(document, 'textarea', 'input', function (e) {
      const textarea = e.target

      const maxlength = textarea.dataset.maxlength
      if (!!maxlength && textarea.value.length >= maxlength) textarea.value = textarea.value.substr(0, maxlength)

      const counter = textarea.parentNode.querySelector('[data-text-area-counter]')
      if (counter) counter.innerHTML = textarea.value.length + '/' + maxlength
    })

    // Automatic setting of styling classes
    Rails.delegate(document, '.input-group select', 'change', function (e) {
      Forms.toggleFilled(e.target)
      Forms.removeErrors(e.target)
    })

    Rails.delegate(document, '.input-group input', 'input', function (e) {
      Forms.toggleFilled(e.target)
      Forms.removeErrors(e.target)
    })

    Rails.delegate(document, '.input-group [type=\'checkbox\']', 'input', function (e) {
      Forms.removeErrors(e.target)
    })

    // Automatic formating of fields
    let cancelFormat = false
    Rails.delegate(document, '[data-formatter]', 'keydown', function (e) {
      const key = e.which || e.keyCode
      if (key === 8 || key === 46) cancelFormat = true
    })

    Rails.delegate(document, '[data-formatter]', 'input', function (e) {
      if (cancelFormat) return
      const input = e.target

      const result = Formatter.apply(input.dataset.formatter, input.value)
      const length = result.length

      input.value = result.substr(0, input.maxLength || length)

      if (input.type === 'text') {
        input.focus()
        input.setSelectionRange(length, length)
      }
    })

    Rails.delegate(document, '[data-formatter]', 'keyup', function (e) {
      cancelFormat = false
    })
  },

  toggleFilled (field) {
    if (field.value.length > 0) {
      field.classList.add('filled')
    } else {
      field.classList.remove('filled')
    }
  },

  removeErrors (field) {
    if (!field.classList.contains('field_with_errors')) return

    field.parentNode.querySelectorAll('.field_with_errors').forEach(function (e) {
      e.classList.remove('field_with_errors')
    })

    const message = field.parentNode.nextElementSibling
    if (message) message.remove()
  }
}

export default Forms
